<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
  <div class="modal-content generalpop-content">
    <div class="modal-header gereral-blue-head">
      <h1 class="modal-title fs-5" id="exampleModalLabel">
        {{ modalTitle }}
      </h1>
      <button type="button" class="pop-close" (click)="closeModal()" aria-label="Close">
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="general-pop-msg">
        <div class="popup-form-hold">
          <div class="modal-desc p-4">
            {{modalDescription}}
            <div class="col-lg-12 details_st row" *ngIf="desc">
              <div class="col-lg-4">
                <h2> {{'cs.description' | translate}}  :</h2>
              </div>
              <div class="col-lg-8">  <p>{{desc}}</p></div>
            </div>
            <div class="col-lg-12 details_st row" *ngIf="comment">
              <div class="col-lg-4">
                <h2> {{'cs.comment' | translate}}  :</h2>
              </div>
              <div class="col-lg-8">  <p>{{comment}}</p></div>
            </div>
          </div>
         
          <div class="next-prev-button-hold mt-4 mb-3" *ngIf="isFooter">
            <a class="blue-btn" (click)="makeOperations(true)">
              <i class="bi bi-file-earmark-check"></i>  {{'common.yes' | translate}}
            </a>
            &nbsp; &nbsp;
            <a class="yellow-btn" (click)="closeModal()">
              <i class="bi bi-x"></i>
              {{'common.no' | translate}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
